<template>
<div id="container_app">
  <div class="locationWrap support">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이용안내
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>공지사항</h2>
      </div>

      <h3 class="subTxt">담다의 새로운 소식 및 뉴스를 전해드립니다.</h3>

      <div class="boardViewWrap board">
        <div class="bvTop">
          <p class="bvTop_tit">{{ board.title }}</p>
          <ul class="bvTop_info">
            <li class="date">등록일  :  {{ dateFmt(board.regDate) }}</li>
            <!--li class="hit">조회수  :  71</li-->
          </ul>
        </div>

        <div class="bvCont" v-html="board.contents">

        </div>
        <div class="bvFile">
          {{ board.files?'':'등록된 첨부파일이 없습니다.'}}
          <span class="file_item" v-for="fileInfo in board.files" v-bind:key="fileInfo.keyid"><a :href="'/web/file/download/' + fileInfo.keyid" target="_blank" ><em v-text="fileInfo.orgFileName"></em></a></span>
          <!--span class="file_item"><em>이미지3.png</em></span>
          <span class="file_item"><em>이미지3.png</em></span>
          <span class="file_item"><em>이미지3.png</em></span-->
        </div>
        <div class="bvNav">
          <ul>
            <li class="bvNav_prev">
              <span class="bvNav_arrow">윗글</span>
              <template v-if="next">
                <a href="javascript:" @click="goDetail(next.keyid)" v-text="next.title"></a>
              </template>
              <template v-else>
                <a href="javascript:">윗글이 없습니다.</a>
              </template>
          </li>
            <li class="bvNav_next">
              <span class="bvNav_arrow">아랫글</span>
              <template v-if="prev">
                <a href="javascript:" @click="goDetail(prev.keyid)" v-text="prev.title"></a>
              </template>
              <template v-else>
                <a href="javascript:">아랫글이 없습니다.</a>
              </template>
            </li>
          </ul>
        </div>
        <div class="btn_box taC mgt56 aniBox type_right gogo">
          <a href="javascript:" class="btn_ty2" @click="prevPage()">목록으로</a>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
// import ScrollLoader from 'vue-scroll-loader'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'SupportNotice',
  components: {
    // ScrollLoader
    InfiniteLoading
  },
  props: ['keyid'],
  data () {
    return {
      board: {},
      next: {},
      prev: {},
      boardNo: this.keyid
    }
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    isImportant: function (val) {
      if (val === 'Y') return true
      else return false
    },
    isNewM: function (dt) {
      var now = moment()
      var regdt = moment(dt)
      return now.diff(regdt, 'days') < 3
    },
    loadData () {
      var _this = this
      axios.get('/web/api/board/NOT/' + _this.boardNo, { withCredentials: true })
        .then(response => {
          if (response.data.result) {
            _this.board = response.data.result
            _this.next = response.data.customs.next
            _this.prev = response.data.customs.prev
          } else {
            _this.board = {}
          }
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    prevPage () {
      this.$router.push('/support/notice')
    },
    goDetail (no) {
      var _this = this
      _this.$router.push('/support/notice/' + no).catch(err => { if (err) console.log('error') })
      _this.boardNo = no
      _this.loadData()
    }
  },
  created () {
  },
  computed: {
  },
  mounted () {
    this.loadData()
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SupportNoticeView.vue